import { render } from "./PoliciesRegulations.vue?vue&type=template&id=35ee63c0&scoped=true"
import script from "./PoliciesRegulations.vue?vue&type=script&lang=js"
export * from "./PoliciesRegulations.vue?vue&type=script&lang=js"

import "./PoliciesRegulations.vue?vue&type=style&index=0&id=35ee63c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ee63c0"]])

export default __exports__